// extracted by mini-css-extract-plugin
module.exports = {"commitMessage":"style_commitMessage__3ubm3nT1rqAMSolCaLWiKt"};